import { render, staticRenderFns } from "./UserTrainingList.vue?vue&type=template&id=06b86102&scoped=true"
import script from "./UserTrainingList.vue?vue&type=script&lang=js"
export * from "./UserTrainingList.vue?vue&type=script&lang=js"
import style0 from "./UserTrainingList.vue?vue&type=style&index=0&id=06b86102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b86102",
  null
  
)

export default component.exports